"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectInputGroupAddon = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ValueContainer = require("./ValueContainer");
var _MenuList = require("./MenuList");
var _Control = require("./Control");
var _Option = require("./Option");
var _InputGroupAddon = require("../InputGroupAddon");
var _select = require("../../select");
var _excluded = ["selectProps"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var ValueContainer = (0, _styledComponents.default)(_ValueContainer.ValueContainer)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-align: end;\n"])));
var SingleValue = (0, _styledComponents.default)(_select.SelectSingleValue)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-right: 32px;\n  width: auto;\n"])));
var Menu = (0, _styledComponents.default)(_select.SelectMenu)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: auto !important;\n"])));
var Control = (0, _styledComponents.default)(_Control.Control)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var SelectInput = (0, _styledComponents.default)(_select.SelectInput).attrs(function () {
  return {
    components: {
      ValueContainer: ValueContainer,
      SingleValue: SingleValue,
      DropdownIndicator: _select.SelectDropdownIndicator,
      MenuList: _MenuList.MenuList,
      Control: Control,
      Option: _Option.Option,
      Menu: Menu
    }
  };
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n"])));
var InputGroupAddon = (0, _styledComponents.default)(_InputGroupAddon.InputGroupAddon)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: end;\n  padding: 0;\n"])));
var SelectInputGroupAddon = function SelectInputGroupAddon(_ref) {
  var selectProps = _ref.selectProps,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(InputGroupAddon, props, /*#__PURE__*/_react.default.createElement(SelectInput, selectProps));
};
exports.SelectInputGroupAddon = SelectInputGroupAddon;